import { render, staticRenderFns } from "./EstadoDesarchivo.vue?vue&type=template&id=643e31cc&"
import script from "./EstadoDesarchivo.vue?vue&type=script&lang=js&"
export * from "./EstadoDesarchivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports